import React from "react";
import "./Switch.scss";

interface ISwitchProps {
    onChange: () => void;
    id?: string;
    defaultChecked?: boolean;
}

const Switch: React.FC<ISwitchProps> = ({ onChange, id, defaultChecked }) => {
    return (
        <label className="switch">
            <input
                type="checkbox"
                id={id}
                defaultChecked={defaultChecked}
                onChange={onChange}
            />
            <span className="slider"></span>
        </label>
    );
};

export default Switch;
